/** Flatten the existing change actions without duplicating their write/Undo handlers. */
export function bindReviewActionChooser(dialog: HTMLElement): void {
  const actions = dialog.querySelector<HTMLElement>(".weekly-review-secondary");
  if (!actions || actions.dataset.chooserBound) return;
  actions.dataset.chooserBound = "true";
  const panels = Array.from(actions.children).map(child => {
    const details = child.tagName === "DETAILS" ? child as HTMLDetailsElement : null;
    const label = details?.querySelector("summary")?.textContent || child.textContent || "Change task";
    const panel = dialog.ownerDocument.createElement("div"); panel.className = "review-action-fields"; panel.hidden = true;
    if (details) { while (details.querySelector(":scope > div")?.firstChild) panel.append(details.querySelector(":scope > div")!.firstChild!); }
    else panel.append(child);
    return { label, panel };
  });
  actions.replaceChildren();
  const label = dialog.ownerDocument.createElement("label"); label.className = "field-label"; label.append("Change");
  const select = dialog.ownerDocument.createElement("select"); select.dataset.reviewChange = "";
  const placeholder = dialog.ownerDocument.createElement("option"); placeholder.value = ""; placeholder.textContent = "Choose an action…"; select.append(placeholder);
  panels.forEach((item, index) => { const option = dialog.ownerDocument.createElement("option"); option.value = String(index); option.textContent = item.label.replace(/[…]+$/, "").trim(); select.append(option); });
  label.append(select); actions.append(label, ...panels.map(item => item.panel));
  select.addEventListener("change", () => panels.forEach((item, index) => { item.panel.hidden = select.value !== String(index); }));
}
